import React, { useState } from "react";
import NextImg from "assets/images/next_history.png";
import PrevImg from "assets/images/prev_history.png";
import * as S from "./style";
import { dataHistory, dataHistoryEN } from "common/constants/dataHistory";
import { useTranslation } from "react-i18next";

const dataDefaultYear = [
  "2022",
  "2021",
  "2020",
  "2019",
  "2018",
  "2017",
  "2016",
];

function History() {
  const [dataYear, setDataYear] = useState(dataDefaultYear[0]);
  const { t, i18n } = useTranslation("common");
  const dataHistoryDefault =
    i18n.language === "kr" ? dataHistory : dataHistoryEN;

  const handleFocus = (data: string) => {
    const dom: any = document?.getElementById(data);
    dom?.focus();
    dom?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    setDataYear(data);
  };

  return (
    <S.Container id="history">
      <div className="container-history">
        <div className="left-container">
          <div className="title">| history</div>
          {dataDefaultYear.map((data, index) => (
            <div
              key={index}
              // className={data === dataYear ? "active" : ""}
              // onClick={() => handleFocus(data)}
            >
              <div
                className={`nameYear ${data === dataYear ? "active" : ""}`}
                onClick={() => handleFocus(data)}
              >
                {data}
              </div>
              {data === dataYear && (
                <>
                  <button
                    className="prev"
                    onClick={() => {
                      if (data !== "2022")
                        handleFocus(String(Number(data) + 1));
                    }}
                    disabled={data === "2022"}
                  >
                    <img src={PrevImg} alt="img" />
                  </button>
                  <button
                    className="next"
                    onClick={() => {
                      if (data !== "2016")
                        handleFocus(String(Number(data) - 1));
                    }}
                    disabled={data === "2016"}
                  >
                    <img src={NextImg} alt="img" />
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
        <div className="right-container">
          {dataHistoryDefault.map((data, index) => (
            <div className="item-container" key={index}>
              <div className="year" id={data.year}>
                {data.year}
              </div>
              <div
                className={`box ${data.year === dataYear ? "box--active" : ""}`}
              >
                {data.content.map((dt, i) => (
                  <div className="item-box" key={i}>
                    <div className={`title ${dt.active ? "year-active" : ""}`}>
                      {dt.year}
                    </div>
                    {dt.content.map((d: string, ind: number) => (
                      <div key={ind} className="content">
                        {d}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </S.Container>
  );
}

export default History;
